var React = require('react');

function HoldBlue (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.70185 575.664C3.70185 575.664 40.2794 649.009 182.721 563.754C325.162 478.499 433.707 434.625 433.707 434.625L618.075 359.481C618.075 359.481 755.706 305.242 716.182 163.352C676.657 21.4618 571.689 0.472762 571.689 0.472762C571.689 0.472762 491.394 -8.78787 310.739 163.352C130.084 335.492 39.1853 464.386 14.7043 497.261C-9.77669 530.135 3.70185 575.664 3.70185 575.664Z","fill":"#0580C4"}));
}

HoldBlue.defaultProps = {"width":"724","height":"605","viewBox":"0 0 724 605","fill":"none"};

module.exports = HoldBlue;

HoldBlue.default = HoldBlue;
